"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const store_1 = __importDefault(require("./store"));
const RibbitRoyalePage = () => {
    const count = (0, store_1.default)((state) => state.count);
    const increaseCount = (0, store_1.default)((state) => state.increaseCount);
    const resetCount = (0, store_1.default)((state) => state.resetCount);
    return (react_1.default.createElement("div", { style: { textAlign: 'center', marginTop: '50px' } },
        react_1.default.createElement("h1", null, "Zustand Counter"),
        react_1.default.createElement("p", null,
            "Current Count: ",
            count),
        react_1.default.createElement("button", { onClick: increaseCount }, "Increase"),
        react_1.default.createElement("button", { onClick: resetCount, style: { marginLeft: '10px' } }, "Reset")));
};
exports.default = RibbitRoyalePage;
